const timeouts = {};

export function setMyTimeout(name, fn, timeout) {
	timeouts[name] = setTimeout(fn, timeout);
}

export function clearMyTimeout(name) {
	clearTimeout(timeouts[name]);
}
